<aside class="card">
  <!-- <img src="/assets/img/bg/project-background.png" alt="" class="card-img-top" alt="..." /> -->
  <app-carousel [development]="development" [notCardImage]=false [BgColor]="'#b5ccd2'"></app-carousel>
  <button class="btn btn-link" role="button" (click)="triggerClose()">
    <i class="icon icon-close icon-white"></i>
  </button>

  <div class="card-body">
    <h4 class="card-title skiptranslate">{{ _development.name | titleCasewithAvoidWords }}</h4>

    <p class="mb-2">
      20-Year Capital Need (2026-2045):
      <strong class="currency">
        {{ twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
      </strong>
    </p>

    <p class="mb-2">
      Total Project Investment (Since 2019):
      <strong class="currency">
        {{ _development.totalInvestment | currency : "USD" : "$" : "1.0-0" }}
      </strong>
    </p>

    <div *ngFor="let project of projectList">
      <h5 *ngIf="project.NoOfProject" style="text-transform:capitalize">{{ project.projectType | titleCasewithAvoidWords }} Projects</h5>

      <ul class="nav">
        <li *ngFor="let item of project.projects" class="nav-item">
          <a [routerLink]="'/projects/'  + item.developmentId + '/' + item.id" class="nav-link text-dark">
            {{ item.name | titleCasewithAvoidWords | simplifyWords}}
          </a>
        </li>

        <li *ngIf="project.NoOfProject > 3" class="nav-item">
          <a [routerLink]="'developments/' + _development.id" class="nav-link text-dark">More...</a>
        </li>
      </ul>
    </div>
  </div>

  <footer class="card-footer d-grid">
    <a
      [routerLink]="'/developments/' + _development.id"
      class="btn btn-primary text-light"
      role="button"
    >
      More Information for this Development
    </a>
  </footer>
</aside>
